import { RootState } from 'store';

export const controlPanelSelector = (state: RootState) => state.controlPanel;
